<template>
  <div class="markPage">
    <Header @setScroll="setScroll" theme="123"></Header>
    <div class="container">
        <img src="../../assets/images/mktImg.png" class="phoneImg"  :src="baseUrl + content.image"/>
        <div class="content">
          <div class="contentTit">{{content.title}}</div>
          <div class="conBox">
            <div class="conItem">
              <span class="label">软件版本：</span><span class="value">{{content.version}}</span>
            </div>
            <div class="conItem conItem2">
              <span class="label">发布时间：</span><span class="value">{{content.publishTime}}</span>
            </div>
          </div>
          <div class="conBox">
            <div class="conItem"><span class="label">软件描述：</span><span class="value">{{content.describe}}</span></div>
          </div>
          <div class="blueBtn" @click="handleApplay">申请应用</div>
        </div>
    </div>

    <!--页脚-->
    <Footer />
    <MarketDialog ref="marketDialog" :id="id"></MarketDialog>
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import MarketDialog from '@/components/marketDialog.vue'
  import {
    serverUrl
  } from '@/utils/server.js'
  import {
    fetchAplicationById
  } from '@/api/api'
  export default {
    data() {
      return {
        scroll: 'home',
        id: '',
        content: {},
        baseUrl: serverUrl.baseURL,
        dialogData: false, // 弹窗显隐
      }
    },
    components: {
      Header,
      Footer,
      MarketDialog
    },
    created() {
      this.id = this.$route.query.data
      // this.getArticleById()
      this.getApplicationById()
    },
    methods: {
      setScroll(eId) {
        this.scroll = eId
      },
      getApplicationById() {
        fetchAplicationById({id: this.id}).then(res=> {
          this.content = res.data
        })
      },
      handleApplay() {
        this.$refs.marketDialog.openDialog(this.content.title)
      }
    }
  }
</script>

<style scoped>
.markPage{
  padding-top: 150px;
  min-height: 100vh;
  background: rgba(223, 239, 255, 0.5) url('../../assets/images/jiao.png') top right no-repeat;
  background-size: 557px 460px;
  /* padding-bottom: 521px; */
}
.container{
  width: 1373px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 100px;

}
.phoneImg{
  width: 635px;
  margin-right: 80px;
}
.content{
  width: 564px;
}
.contentTit{
  font-size: 48px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #121E30;
  margin-bottom: 46px;
}
.conItem{
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #8995A8;
  line-height: 30px;
}
.conItem .label {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #8995A8;
}
.conItem .value{
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #121E30;
}
.conBox{
  margin-bottom: 36px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.conItem2{
  margin-left: 84px;
}
.blueBtn{
  background: #0F5EFF;
  box-shadow: 1px 4px 24px 0px rgba(110,154,229,0.57);
  border-radius: 30px;
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 36px;
  padding: 10px 76px;
  display: inline-block;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/market/MarketDetails.vue